import React from "react";
import { type IconProp } from "@fortawesome/fontawesome-svg-core";
import FontAwesomeLight from "../../Utilities/Platform/FontAwesome/FontAwesomeLight";
import Button from "../Buttons/Button";

export type CalendarModeType = "date" | "time" | "month";

type Props = {
    selected: CalendarModeType;
    mode: CalendarModeType;
    icon: IconProp;
    onSelect: (mode: CalendarModeType) => void;
};

export default class CalendarModeSelection extends React.Component<Props> {
    public handleClick = (): void => {
        this.props.onSelect(this.props.mode);
    };

    public render(): React.ReactNode {
        const classes = [ "calendar-mode-selection" ];

        if(this.props.selected === this.props.mode) {
            classes.push("selected");
        }

        return (
            <Button
                type="button"
                classes={classes}
                onClick={this.handleClick}
            >
                <FontAwesomeLight icon={this.props.icon} />
            </Button>
        );
    }
}
